import { useAuthState } from 'contexts/auth-context';

const useAccess = rules => {
  const state = useAuthState();
  const { role } = state.auth.user;
  let permissionState = state.permission || [];
  let access = false;

  if (rules.includes(role)) {
    access = true;
  }
  rules.forEach(rule => {
    if (permissionState.includes(rule)) {
      access = true;
    }
  });

  return access;
};

export default useAccess;
